import { render, staticRenderFns } from "./SyllabusComments.vue?vue&type=template&id=fdf13a5e&"
import script from "./SyllabusComments.vue?vue&type=script&lang=js&"
export * from "./SyllabusComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports